var plugins = [{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/node_modules/gatsby-plugin-jss/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/themes/typography"},
    },{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-24159386-1","head":false},
    },{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser'),
      options: {"plugins":[],"pixelId":"1813501258922708"},
    },{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/node_modules/gatsby-plugin-sentry/gatsby-browser'),
      options: {"plugins":[],"dsn":"https://8cb64ec80165437b98905b07296ddc3f@sentry.io/1232334"},
    },{
      plugin: require('/home/travis/build/gladly-team/tab-homepage/gatsby-browser'),
      options: {"plugins":[]},
    }]
// During bootstrap, we write requires at top of this file which looks
// basically like:
// var plugins = [
//   {
//     plugin: require("/path/to/plugin1/gatsby-browser.js"),
//     options: { ... },
//   },
//   {
//     plugin: require("/path/to/plugin2/gatsby-browser.js"),
//     options: { ... },
//   },
// ]

export function apiRunner(api, args, defaultReturn) {
  let results = plugins.map(plugin => {
    if (plugin.plugin[api]) {
      const result = plugin.plugin[api](args, plugin.options)
      return result
    }
  })

  // Filter out undefined results.
  results = results.filter(result => typeof result !== `undefined`)

  if (results.length > 0) {
    return results
  } else if (defaultReturn) {
    return [defaultReturn]
  } else {
    return []
  }
}

export function apiRunnerAsync(api, args, defaultReturn) {
  return plugins.reduce(
    (previous, next) =>
      next.plugin[api]
        ? previous.then(() => next.plugin[api](args, next.options))
        : previous,
    Promise.resolve()
  )
}



// WEBPACK FOOTER //
// ./.cache/api-runner-browser.js